<template>
  <v-dialog v-model="dialog" width="90%">
    <v-card elevation="3">

      <div class="pp-sidenav">
        <div class="white--text text-h6 pt-2 pl-5">
          Publish a Vimeo / Youtube
        </div>

      </div>

      <v-img
          src="/images/pp-logo.png"
          height="40"
          contain
          class="logo-course"
      >
      </v-img>

      <v-tabs
          dark
          width="250"
          color="primary"
          vertical
      >
        <v-tab class="pp-sidenav-2">
          <v-icon left>
            mdi-plus
          </v-icon>
          Vimeo/Youtube Details
        </v-tab>

        <v-tab-item>
          <v-card flat>
            <v-container>
              <template>
                <v-card
                    color="grey lighten-4"
                    width="100%" flat
                >
                  <v-card-title class="text-h6 grey lighten-3">
                    Add Vimeo/Youtube Details
                  </v-card-title>

                  <div class="py-5 pa-3">
                    <v-card-text>
                      <v-row>
                        <v-text-field
                            v-model="add.title"
                            aria-required="true"
                            color="primary"
                            label="Vimeo/Youtube Title"
                            placeholder="Add a Vimeo/Youtube Title"
                            prepend-icon="mdi-file-edit-outline"
                            flat
                            solo
                            clearable
                        ></v-text-field>
                      </v-row>

                      <v-row v-if="videoApiError && videoApiError.fields && videoApiError.fields.title" class="err-text">
                        <p class="error--text">
                          Vimeo/Youtube's title should not be empty and contain letters and/or numbers.
                        </p>
                      </v-row>

                      <v-row>
                        <v-text-field
                            v-model="add.uri"
                            aria-required="true"
                            color="primary"
                            label="Vimeo/Youtube URL"
                            placeholder="Add a Vimeo/Youtube URL"
                            prepend-icon="mdi-web"
                            flat
                            solo
                            clearable
                        ></v-text-field>
                      </v-row>

                      <v-row v-if="videoApiError && videoApiError.fields && videoApiError.fields.uri" class="err-text">
                        <p class="error--text">
                          Vimeo/Youtube's URL should not be empty and contain a URL.
                        </p>
                      </v-row>

                      <v-row>
                        <v-select
                            v-model="add.aspectRatio"
                            aria-required="true"
                            :items="aspectRatios"
                            color="primary"
                            label="Aspect Ratio"
                            prepend-icon="mdi-resize"
                            flat
                            solo
                            clearable
                        ></v-select>
                      </v-row>

                      <v-row v-if="videoApiError && videoApiError.fields && videoApiError.fields.aspectRatio" class="err-text">
                        <p class="error--text">
                          Please select an aspect ratio for the Vimeo/Youtube.
                        </p>
                      </v-row>

                      <v-row>
                        <v-textarea
                            v-model="add.description"
                            auto-grow hint="The description of the video will be publicly visible"
                            persistent-hint
                            label="Vimeo/Youtube Description"
                            class="mb-5"
                            aria-required="true"
                            color="primary"
                            placeholder="Add a Vimeo/Youtube Description"
                            prepend-icon="mdi-format-line-style"
                            flat
                            solo
                            clearable
                        >
                        </v-textarea>
                      </v-row>

                      <v-row v-if="videoApiError && videoApiError.fields && videoApiError.fields.description" class="err-text">
                        <p class="error--text">
                          Vimeo/Youtube's description should not be empty and contain letters and/or numbers.
                        </p>
                      </v-row>

                      <ImagePicker v-model="add.image"/>

                      <TagsInput
                          v-model="add.tags"
                          :validationError="videoApiError"
                      />

                      <v-row v-if="videoApiError">
                        <v-alert
                            text
                            color="red"
                            icon="mdi-alert-circle-outline"
                        >
                          There was an error in submission. Please check all fields and try again.
                        </v-alert>
                      </v-row>
                    </v-card-text>
                  </div>
                </v-card>
              </template>
            </v-container>
          </v-card>
        </v-tab-item>
      </v-tabs>

      <!-- ------------------------------------------ buttons ------------------------------------------ -->

      <div class="pp-sidenav">
        <div class="btm">
          <Loading v-if="videoItemLoading" />

          <ConfirmCancelButtons
              :item="add"
              :cancel-action="closeDialog"
              :confirm-action="addItemConfirm"
              confirm-text="Create Video"
              :confirm-disabled="videoItemLoading"/>
        </div>
      </div>
      <!-- ------------------------------------------end of buttons ------------------------------------------ -->
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import ImagePicker from "@/components/common/ImagePicker";
import Loading from "@/components/common/Loading";
import TagsInput from "@/components/common/TagsInput";

export default {
  name: "VideoAdd",
  components: {
    TagsInput,
    Loading, ImagePicker, ConfirmCancelButtons,
  },
  data() {
    return {
      add: {
        title: '',
        description: '',
        aspectRatio: '',
        image: undefined,
        uri: '',
        tags: [],
      },
    };
  },
  computed: {
    ...mapGetters(['videoApiError', 'openDialog', 'videoItemLoading', 'aspectRatios']),
    dialog: {
      get () {
        return this.openDialog === 'videoAdd';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
  },
  methods: {
    ...mapActions(['addVideo','setOpenDialog', 'closeOpenDialog']),
    closeDialog() {
      this.reset();
    },
    async addItemConfirm() {
      const added = await this.addVideo(this.add);

      if (added) {
        this.reset();
      }
    },
    reset() {
      this.closeOpenDialog();
      this.add  = {
        title: '',
        description: '',
        aspectRatio: '',
        image: undefined,
        uri: '',
        tags: [],
      };
    },
  },
};
</script>
